import { NetworkErrorComponent } from './network-error.component';

export default angular
  .module('sfMobile.components.networkError', [
    'pascalprecht.translate',
    'sfMobile.templates',
    'sfMobile.components.information-display',
  ])
  .component('sfNetworkError', NetworkErrorComponent).name;
